import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { environment } from 'environments/environment';
import { first, map, Observable, of, ReplaySubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private _httpClient = inject(HttpClient);
    private _navigation: ReplaySubject<Navigation> =
        new ReplaySubject<Navigation>(1);
    private _tokenValue: string = '';
    requested = false;
    requestToken = false;
    loginId = '';
    private uri = environment.apiUrl + 'master/';
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    get embedToken(): string {
        return this._tokenValue;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        if (this.requested && this.loginId == sessionStorage.getItem('u')) {
            return this._navigation.pipe(first());
        }

        if (sessionStorage.getItem('issu') == 'true') {
            return this._httpClient
                .get<Navigation>('api/common/navigation')
                .pipe(
                    tap((navigation) => {
                        this._navigation.next(navigation);
                        // console.log(navigation);
                    })
                );
        } else {
            return this._httpClient
                .get<Navigation>(this.uri + 'getDynamicMenu')
                .pipe(
                    tap((navigation) => {
                        this._navigation.next(navigation['payload']);
                        this.requested = true;
                        this.loginId = sessionStorage.getItem('u');
                    })
                );
        }
    }
    
    getToken(): Observable<string> {
        if (!this.requestToken){
            this.requestToken = true;
            return this._httpClient.get<any>(this.uri + 'getToken').pipe(
                map((response) => response?.payload?.data?.token ?? ''),
                tap((token) => {
                    this._tokenValue = token;
                })
            );
        }
        return of('');
    }
}
